var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c(
      "td",
      [
        _c(
          "router-link",
          { attrs: { to: `/resources/${_vm.resource.id}/basics` } },
          [_vm._v("\n            " + _vm._s(_vm.resource.title) + "\n        ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        "\n        " +
          _vm._s(_vm.resource.user.firstName) +
          " " +
          _vm._s(_vm.resource.user.lastName) +
          ", " +
          _vm._s(
            _vm.resource.organization ? _vm.resource.organization.name : ""
          ) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm._f("capitalize")(_vm.resource.status)))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }